import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const deliveryData = createSlice({
    name: "deliveryData",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setDeliveryDataReducer: (state, action) => {
            state.value = action.payload;
        },
        clearDeliveryDataReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setDeliveryDataReducer, clearDeliveryDataReducer } = deliveryData.actions;
export default deliveryData.reducer;
